export default "__VITE_ASSET__Do9XLS4J__"